import { FC } from 'react'

import {
  IconTrashCan,
  Button,
  GreyGrey60,
  Tooltip,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'

import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const DeleteNoteModal: FC<{
  activityLogId: string
}> = ({ activityLogId }) => {
  const { displayNotification } = useNotifications()

  const deleteMutation = useMutation(
    dashboardv99990101Client.deleteActivityLogNote,
    {
      onSuccess: () => {
        displayNotification('Note deleted', { type: 'success' })
      },
      onError: () => {
        displayNotification('Unable to delete note', { type: 'error' })
      }
    }
  )

  return (
    <SimpleModal
      trigger={
        <Tooltip label="Delete note">
          <Button
            variant="ghost"
            icon={<IconTrashCan color={GreyGrey60} />}
            aria-label="Delete note"
            size="24px"
            data-testid="activity-log.note.delete"
          />
        </Tooltip>
      }
      variant="dialog"
      title="Delete note"
      submitButtonText="Delete"
      submittingButtonText="Deleting..."
      isDestructive
      onSubmit={async () => {
        const res = await deleteMutation.mutateAsync({ activityLogId })
        return Boolean(res)
      }}
    >
      Are you sure you want to delete this note?
    </SimpleModal>
  )
}
